module.exports = __webpack_public_path__ + "img/ckcc.bb99bfba.jpg";